import React from "react";
import {connect} from "react-redux";
import {Bid, Lot, Participant} from "@nextlot/core/webcast/data/data_types_definitions";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {TaggedLogger} from "@nextlot/core/utilities";
import {AuctionsManager} from "@nextlot/core/webcast";
import {ReduxWebcastCurrentRoundBiddingType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRoundBidding";
import {RoundStopTypeEnum, RoundTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {ReduxWebcastAuctionDataType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastAuctionData";

type RootCmpPropsType = {
    currentRound: ReduxWebcastCurrentRoundType,
    currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
    auctionData: ReduxWebcastAuctionDataType,
    participantsByUserId: Map<number, Participant>,
}


type RootCmpStateType = {
    lotsSelection: {}
}


const _logger = TaggedLogger.get('ClerkRoundChoiceLotsSelectConfirmCmp');

class ClerkRoundChoiceLotsSelectConfirmCmp extends React.Component<RootCmpPropsType, RootCmpStateType> {
    private readonly clerkUserId: number;

    constructor(props) {
        super(props);
        _logger.debug('.constructor() props:', props);

        // we are the Clerk, get the participantId
        this.clerkUserId = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantId;

        this.state = {
            lotsSelection: {}
        };
    }



    isLotInputRadioChecked = (lotId:number, userId:number) => {
        const radioInputName = `lot_${lotId}`;
        const currentRoundBidding:ReduxWebcastCurrentRoundBiddingType = this.props.currentRoundBidding;
        return ((this.state.lotsSelection[radioInputName] || currentRoundBidding.choiceLotsSelectionMap.get(lotId)) === userId);
    };



    handleChange_LotSelectInputRadio = (lotId:number, selectedUserId:number) => (evt) => {
        this.setState({
            lotsSelection: {
                ...this.state.lotsSelection,
                [`lot_${lotId}`]: selectedUserId,
            }
        })
    };


    handleClick_SelectAllButton = (userId:number) => (evt) => {
        const newStateLotsSelection = {
            ...this.state.lotsSelection
        };
        this.props.currentRound.lotsIds.forEach((lotId:number) => {
            newStateLotsSelection[`lot_${lotId}`] = userId;
        });
        this.setState({
            lotsSelection: newStateLotsSelection
        })
    };


    _computeSelectionLotsIdsAndUsersIdsFromState():{ lotsIds:Array<number>, usersIds:Array<number> } {
        _logger.debug('_computeSelectionLotsIdsAndUsersIdsFromState: ', this.state.lotsSelection);
        const currentRoundBidding:ReduxWebcastCurrentRoundBiddingType = this.props.currentRoundBidding;
        const lotsIds = [];
        const usersIds = [];
        this.props.currentRound.lotsIds.forEach((lotId) => {
            const radioInputName = `lot_${lotId}`;
            const userId = this.state.lotsSelection[radioInputName] || currentRoundBidding.choiceLotsSelectionMap.get(lotId);
            if (userId) {
                lotsIds.push(lotId);
                usersIds.push(userId);
            }
        });

        _logger.debug('_computeSelectionLotsIdsAndUsersIdsFromState: arrays ', lotsIds, usersIds);
        return { lotsIds, usersIds };
    }

    handleClick_SubmitAndReopenChoiceButton = () => {
        const { lotsIds, usersIds } = this._computeSelectionLotsIdsAndUsersIdsFromState();
        AuctionsManager.currentWebcastAuctionHandler.controller.sendChoiceLotsAssignment(this.props.currentRoundBidding.roundId, lotsIds, usersIds, RoundTypeEnum.GROUP_CHOICE_REOPEN);
    };

    handleClick_SubmitAndStartNewRoundButton = () => {
        const { lotsIds, usersIds } = this._computeSelectionLotsIdsAndUsersIdsFromState();
        AuctionsManager.currentWebcastAuctionHandler.controller.sendChoiceLotsAssignment(this.props.currentRoundBidding.roundId, lotsIds, usersIds, RoundTypeEnum.GROUP_CHOICE);
    };

    handleClick_CancelButton = () => {
        AuctionsManager.currentWebcastAuctionHandler.controller.sendRoundStop(this.props.currentRoundBidding.roundId, RoundStopTypeEnum.CANCEL);
    };





    renderChoiceLotListItem = (lotId:number, hasInternetBidder:boolean, winnerBidderUserId:number, highestBid:Bid) => {
        const currentRoundBidding:ReduxWebcastCurrentRoundBiddingType = this.props.currentRoundBidding;
        const lot:Lot = this.props.auctionData.lotsMapById.get(lotId);
        const radioInputName = `lot_${lotId}`;

        const bidderUserId:number = winnerBidderUserId > 0 ? winnerBidderUserId : currentRoundBidding.choiceLotsSelectionMap.get(lotId);
        const bidderDisplay:string = bidderUserId > 0 ? (this.props.participantsByUserId.get(bidderUserId) || highestBid || { bidderDisplay: '[bidder]' }).bidderDisplay : '[internet bidder]';

        const isBidderChecked = bidderUserId && this.isLotInputRadioChecked(lotId, bidderUserId);
        const isFloorChecked = this.isLotInputRadioChecked(lotId, this.clerkUserId);
        const isNoneChecked = ! (isBidderChecked || isFloorChecked);



        return (
            <div key={lotId} className="choice-lots__list-item">
                <div className="list-item__lot-label">
                    <span className="lot-label__no">{lot.number}</span>
                    <span className="lot-label__name">{lot.name}</span>

                    {
                        currentRoundBidding.choiceLotsSelectionMap && currentRoundBidding.choiceLotsSelectionMap.get(lot.id)
                        && <span className="lot-label__pointer">{'\u27F9'}</span>
                    }
                </div>
                <div className="list-item__radio-group">
                    {
                        hasInternetBidder && (
                            bidderUserId > 0
                                ? <label className="bidder"><input type="radio" name={radioInputName} onChange={this.handleChange_LotSelectInputRadio(lotId, bidderUserId)}
                                                                   value={bidderUserId}
                                                                   checked={isBidderChecked}
                                /> {bidderDisplay}</label>
                                : <label className="bidder">[internet bidder]</label>
                        )
                    }
                    <label><input type="radio" name={radioInputName} onChange={this.handleChange_LotSelectInputRadio(lotId, this.clerkUserId)}
                                  value={this.clerkUserId}
                                  checked={isFloorChecked}
                    /> Floor</label>
                    <label><input type="radio" name={radioInputName} onChange={this.handleChange_LotSelectInputRadio(lotId, 0)}
                                  checked={isNoneChecked}
                                  value={0} /> None</label>
                </div>
            </div>
        )
    };



    render() {
        _logger.debug('.render() props:', this.props, '  state:', this.state);

        const highestBid:Bid = this.props.currentRoundBidding.highestBid;
        // for CHOICE_REOPEN, we consider the winner=false
        const winnerUserId = this.props.currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN ? false : highestBid.userId;
        const internetBidderUserId = (winnerUserId !== false) && (winnerUserId !== this.clerkUserId) ? winnerUserId : 0;
        const hasInternetBidder:boolean = (winnerUserId === false) || (winnerUserId !== this.clerkUserId);

        return (
            <div className={`clerk-choice-lots-select-container ${hasInternetBidder ? 'has-internet-bidder' : null}`}>
                <div className="choice__header">
                    <h4>Assign Lots</h4>
                    <div className="header__buttons-group">
                        {
                            hasInternetBidder &&
                            (internetBidderUserId > 0
                                    ?  <button className="bidder btn btn-outline-dark btn-sm" type="button" onClick={this.handleClick_SelectAllButton(internetBidderUserId)}>Bidder</button>
                                    :  <span className="bidder">Bidder</span>
                            )
                        }
                        <button type="button" className="btn btn-outline-dark btn-sm" onClick={this.handleClick_SelectAllButton(this.clerkUserId)}>Floor</button>
                        <button type="button" className="btn btn-outline-dark btn-sm" onClick={this.handleClick_SelectAllButton(0)}>None</button>
                    </div>
                </div>
                <div className="choice__body">
                    <div className="choice-lots-list-scrollable-container">
                        {this.props.currentRound.lotsIds.map(lotId => this.renderChoiceLotListItem(lotId, hasInternetBidder, internetBidderUserId, highestBid))}
                    </div>
                </div>
                <div className="choice__footer">
                    <button type="button" className="btn btn-primary" onClick={this.handleClick_SubmitAndReopenChoiceButton}>Submit and Re-open Choice</button>
                    <button type="button" className="btn btn-primary" onClick={this.handleClick_SubmitAndStartNewRoundButton}>Submit and Start New</button>
                    <button type="button" className="btn btn-outline-warning" onClick={this.handleClick_CancelButton}>Cancel</button>
                </div>
            </div>
        );
    }
}

export default connect(({ activeWebcast }: {activeWebcast:ReduxActiveWebcastSubStateType}) => {
    return {
        auctionData: activeWebcast.webcastAuctionData,
        participantsByUserId: activeWebcast.webcastParticipants.mapByUserId,
    };
})(ClerkRoundChoiceLotsSelectConfirmCmp);


